import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import HomePage from './pages/HomePage';
import ProductDetailPage from './pages/ProductDetailPage';
import ProjectDetailPage from './pages/ProjectDetailPage';
import ProjectsPage from './pages/ProjectsPage';
import QuoteForm from './components/QuoteForm';

function App() {
  const [isQuoteFormOpen, setIsQuoteFormOpen] = useState(false);

  return (
    <Router>
      <div className="bg-white font-sans">
        <Header onGetQuoteClick={() => setIsQuoteFormOpen(true)} />
        <Routes>
          <Route path="/" element={<HomePage onGetQuoteClick={() => setIsQuoteFormOpen(true)} />} />
          <Route path="/projects" element={<ProjectsPage />} />
          <Route path="/project/:projectId" element={<ProjectDetailPage />} />
          <Route path="/:productId" element={<ProductDetailPage onGetQuoteClick={() => setIsQuoteFormOpen(true)} />} />
        </Routes>
        <Footer />
        <QuoteForm isOpen={isQuoteFormOpen} onClose={() => setIsQuoteFormOpen(false)} />
      </div>
    </Router>
  );
}

export default App;
